import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import LeadsList from './LeadsList.js';

export default compose(

  graphql(gql`
    mutation createLead(
      $device_type_id: String!,
      $problem_type_id: String!,
      $status_id: String!,
      $model: String!,
      $comment: String!,
      $client_id: String!,
      $delivery_time: String!,
      $delivery_date: String!,
      $delivery_address: String!,
      $delivery_brand: String!,
      $delivery_to_client: Boolean,
      $first_call_by_id: String,
      $created_by_id: String,
      $confirmed_by_id: String,
    ) {
      createLead(
        lead: {
          device_type_id: $device_type_id,
          problem_type_id: $problem_type_id,
          status_id: $status_id,
          model: $model,
          comment: $comment,
          client_id: $client_id,
          delivery_time: $delivery_time,
          delivery_date: $delivery_date,
          delivery_address: $delivery_address,
          delivery_brand: $delivery_brand,
          delivery_to_client: $delivery_to_client,
          first_call_by_id: $first_call_by_id,
          created_by_id: $created_by_id,
          confirmed_by_id: $confirmed_by_id,
        }
      ) {
        id,
        created_at
      }
    }
  `, {
    name:'createLead'
  }),

  graphql(gql`
    mutation updateLead(
      $id: String!,
      $device_type_id: String!,
      $problem_type_id: String!,
      $status_id: String!,
      $model: String!,
      $comment: String!,
      $delivery_time: String!,
      $delivery_date: String!,
      $delivery_address: String!,
      $delivery_brand: String!,
      $delivery_to_client: Boolean,
      $first_call_by_id: String,
      $created_by_id: String,
      $confirmed_by_id: String,
    ) {
      updateLead(
        lead: {
          id: $id,
          device_type_id: $device_type_id,
          problem_type_id: $problem_type_id,
          status_id: $status_id,
          model: $model,
          comment: $comment,
          delivery_time: $delivery_time,
          delivery_date: $delivery_date,
          delivery_address: $delivery_address,
          delivery_brand: $delivery_brand,
          delivery_to_client: $delivery_to_client,
          first_call_by_id: $first_call_by_id,
          created_by_id: $created_by_id,
          confirmed_by_id: $confirmed_by_id,
        }
      ) {
        id,
        created_at
      }
    }
  `, {
    name:'updateLead'
  }),

  graphql(gql`
    mutation removeLead(
      $id: String!,
    ) {
      removeLead(
        lead: {
          id: $id,
        }
      ) {
        id
      }
    }
  `, {
    name:'removeLead'
  }),

)(LeadsList);